export default "__VITE_ASSET__47e78a97__"